import { Application, Controller } from "@hotwired/stimulus";

// NFT発行・確認系アクション（コントラクト作成 / 作成確認 / トークン追加 / 発行確認）リンクの
// 二度押し防止。一度クリックしたら無効化し、2回目以降の送信を抑止する。
// サーバ側にも状態機械ガード(before_action)があり、本コントローラはその手前で多重送信を減らす役割。
class NftAccessController extends Controller {
  static targets = ['accessLink']

  connect() {
    if (!this.hasAccessLinkTarget) return;

    this.submitted = false;
    this.boundDisableLink = this.disableLink.bind(this);
    this.accessLinkTargets.forEach((link) => link.addEventListener('click', this.boundDisableLink));
  }

  disconnect() {
    if (!this.boundDisableLink) return;

    this.accessLinkTargets.forEach((link) => link.removeEventListener('click', this.boundDisableLink));
  }

  disableLink(event) {
    // 2回目以降のクリックは送信させない（pointer-events だけに頼らずJSでも抑止）。
    if (this.submitted) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    this.submitted = true;
    const link = event.currentTarget;
    link.classList.add("disabled");

    // turbo_confirm がある場合、window.confirm() は同期・ブロッキングで実行され、
    // Turbo のハンドラ（document への伝播後）が完了してから setTimeout(0) が走る。
    // ナビゲーションが始まれば turbo:before-visit が同期的に発火するため、
    // setTimeout(0) 時点で visitStarted が true かどうかでキャンセルを検知できる。
    if (link.dataset.turboConfirm) {
      let visitStarted = false;
      const onBeforeVisit = () => { visitStarted = true; };
      document.addEventListener("turbo:before-visit", onBeforeVisit, { once: true });

      setTimeout(() => {
        document.removeEventListener("turbo:before-visit", onBeforeVisit);
        if (!visitStarted) {
          // confirm がキャンセルされた → リンクを再有効化
          this.submitted = false;
          link.classList.remove("disabled");
        }
      }, 0);
    }
  }
}

// Registered in admin.js
export { NftAccessController };
